import React, { Component } from "react";
import { monthOptions, yearOptions } from "../config";
import FlexView from "react-flexview";
import * as R from "ramda";
import { configFincoyGrowth } from "./config";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleUploadImage from "../../../../../modules/upload/SimpleUploadImage";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import CardBartChart from "../../../../../cards/SimpleBarchart";
import { service } from "./service";

class FincoyGrowthReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
      chartVisible: false,
      dataKey: [],
    };
  }

  componentDidMount = () => {
    let currentDate = new Date();
    this.setState(
      (prevValue) => ({
        ...prevValue,
        month: monthOptions.find(
          (item) => item.value === currentDate.getMonth() + 1,
        ),
        year: yearOptions.find(
          (item) => item.value === currentDate.getFullYear(),
        ),
        tableConfig: configFincoyGrowth,
      }),
      () => {
        if (this.props.search) {
          this.fetchData();
        }
      },
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (!R.equals(this.props.search, prevProps.search)) {
      this.fetchData();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  constructTable = () => {
    return this.state.dataTable.map((item) => {
      if (!R.isNil(item)) {
        return (
          <SimpleDataTable
            key={item.nameFincoy}
            title={item?.nameFincoy}
            data={item?.data}
            columns={configFincoyGrowth}
            options={{ serverSide: false, pagination: false }}
          />
        );
      }
    });
  };

  constructChart = () => {
    return this.state.dataTable.map((item, index) => {
      if (!R.isNil(item)) {
        const dataKey = service.parseDataKeyFincoyBranch(item.data);
        const dt = service.parseDataChartFincoyBranch(item.data);
        return (
          <CardBartChart key={`chart-${index}`} data={dt} dataKey={dataKey} />
        );
      }
      return <></>;
    });
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  fetchData = async () => {
    this.props.handleTriggerLoading();
    let dataKodeCabang = this.props.search;
    if (this.props.isAllSelected) {
      dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang);
    }

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanGrowthFincoyMTDPercabang,
      setError: this.props.setError,
      menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Fincoy Growth",
      args: {
        kodeCabang: dataKodeCabang,
        month: this.state.month?.value,
        year: this.state.year?.value,
        employeeIdTeamLeader: this.props.idLeader,
      },
    });

    this.props.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
      }));
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "20px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <FlexView
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "20px",
                width: "100%",
              }}
            >
              {this.constructTable()}
            </div>
          </FlexView>
        )}
        {/* {this.state.chartVisible && this.constructChart()} */}
        {this.state.chartVisible && (
          <FlexView
            style={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "20px",
                width: "100%",
              }}
            >
              {this.constructChart()}
            </div>
          </FlexView>
        )}
        <FlexView style={{ marginTop: "20px", justifyContent: "end" }}>
          <SimpleButton onClick={this.handleChartVisibility}>
            Chart
          </SimpleButton>
        </FlexView>
      </>
    );
  }
}

export default FincoyGrowthReport;
